<template>
  <div class="events">
    <el-container>
      <el-main style="margin:0px;padding:0px;" >
        <el-row style="margin:0px;padding:0px;">
          <span style="font-size: 22px;">公司重要事件</span>
        </el-row>
        <el-row>
          <el-col :span="2">
            <img width="60px" height="60px" src="@/assets/image/event_point.png">
          </el-col>
          <el-col :span="22"  style="margin-top:12px;">
            <span style="font-size: 20px;">2020年02月08日，合肥成蹊科技服务有限责任公司官网上线试运行。</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <img width="60px" height="60px" src="@/assets/image/event_point.png">
          </el-col>
          <el-col :span="22" style="margin-top:12px;">
            <span style="font-size: 20px;">2019年12月01日，博信农业科技入驻成蹊防伪溯源平台。</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <img width="60px" height="60px" src="@/assets/image/event_point.png">
          </el-col>
          <el-col :span="22"  style="margin-top:12px;">
            <span style="font-size: 20px;">2019年11月01日，坤元农业科技入驻成蹊防伪溯源平台。</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <img width="60px" height="60px" src="@/assets/image/event_point.png">
          </el-col>
          <el-col :span="22"  style="margin-top:12px;">
            <span style="font-size: 20px;">2019年08月08日，合肥成蹊科技服务有限责任公司正式注册成立。</span>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'seedTracePage'
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.events {
  margin-left: 0px;
  padding-left: 20px;
  height: 500px;
}
.el-row {
  margin-top: 10px;
  padding-top: 10px;
  text-align: left;
}
</style>
